export const PRIMARY_LOCATION = "PRIMARY";
export const FOOTER_LOCATION = "FOOTER";
export const ALT_MENU_LOCATION = "ALT_MENU";
